module.exports = __webpack_public_path__ + "img/boy.afba6ccd.png";